<!--  -->
<template>
  <div class="singleSelect" v-show="show" @click.self="show = false">
    <div class="content">
      <div class="list" :class="{active:item.checked}" v-for="(item, k) in selectList" :key="k" @click="change(item)">
        <b>{{ item.name }}</b>
        <img :src="item.checked ? checked : check" alt="" />
      </div>
      <div class="btn">
        <div @click="show = false">取消</div>
        <div @click="confirm">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    currentSelect: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    currentSelect: {
      immediate: true,
      deep: true,
      handler(data) {
        this.selectList = JSON.parse(JSON.stringify(data));
      },
    },
  },

  data() {
    return {
      selectList: [],
      show: false,
      check: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/trainingCamp/check.png',
      checked:
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/trainingCamp/checked.png',
    };
  },
  computed: {},
  methods: {
    change(data) {
      this.selectList.forEach((ele) => {
        if (ele.value === data.value) {
          Object.assign(ele, { checked: !ele.checked });
        }
      });
    },
    confirm() {
      this.$emit('selectRes', this.selectList);
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.singleSelect {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;
  background: rgba($color: #000, $alpha: 0.5);
  .content {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    min-height: 251px;
    padding: 43px 0;
    background: #fff;
    border-radius: 36px 36px 2px 2px;
    box-shadow: 0 -4 20px 0 rgba(0, 0, 0, 0.1);
    .list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 87px;
      margin-bottom: 18px;
      padding: 0 58px;
      b {
        color: #333;
        font-weight: 400;
        font-size: 25px;
      }
      img {
        width: 29px;
        height: 29px;
      }
    }
    .list.active {
      background: #fff3ee;
      b {
        color: #ff7f41;
      }
    }
    .btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 36px;
      div {
        width: 330px;
        height: 80px;
        color: #ff7f41;
        font-weight: 500;
        font-size: 29px;
        line-height: 80px;
        text-align: center;
        background: #fff;
        border: 2px solid #ff7f41;
        border-radius: 45px;
      }
      div:last-child {
        color: #fff;
        background: #ff7f41;
      }
    }
  }
}
</style>
